<template>
  <b-card>
    <b-table
      :items="reChangeFormat"
      :fields="fields"
      small
      :busy="loader"
      responsive
      bordered
      striped
      show-empty
    >
      <template #head()="data">
        <span>{{ $t(`${data.label}`) }}</span>
      </template>
      <template #table-busy>
        <div
          class="text-success my-2 d-flex justify-content-center align-items-center"
        >
          <b-spinner />
          <strong class="px-1">Loading...</strong>
        </div>
      </template>
      <template #empty>
        <div class="text-center text-danger my-2">
          <strong>
            {{ $t('objects.no_data') }}
          </strong>
        </div>
      </template>
      <template #thead-top>
        <b-tr class="text-center">
          <b-th colspan="24">
            {{ $t('general.expired_debt') }}
          </b-th>
        </b-tr>
        <b-tr class="text-center">
          <b-th colspan="2">
            <span class="sr-only">Name and ID</span>
          </b-th>
          <b-th colspan="2">
            {{ $t('general.last') }}
          </b-th>
          <b-th
            v-for="(item, index) in relatedPerson"
            :key="index"
            variant="secondary"
            colspan="2"
          >
            {{ item[$i18n.locale] }}
          </b-th>
        </b-tr>
      </template>
      <template #cell(total_month_debt)="props">
        {{ $_moneyFormatter(props.item.total_month_debt) }}
      </template>
      <template #cell(iftixor_debt)="props">
        {{ $_moneyFormatter(props.item.iftixor.month_debt) }}
      </template>
      <template #cell(elbek_debt)="props">
        {{ $_moneyFormatter(props.item.elbek.month_debt) }}
      </template>
      <template #cell(giyos_debt)="props">
        {{ $_moneyFormatter(props.item.giyos.month_debt) }}
      </template>
      <template #cell(shuhrat_debt)="props">
        {{ $_moneyFormatter(props.item.shuhrat.month_debt) }}
      </template>
      <template #cell(elyor_debt)="props">
        {{ $_moneyFormatter(props.item.elyor.month_debt) }}
      </template>
      <template #cell(feruz_debt)="props">
        {{ props.item.feruz && $_moneyFormatter(props.item.feruz.month_debt) }}
      </template>
      <template #cell(xodim_debt)="props">
        {{ $_moneyFormatter(props.item.xodim.month_debt) }}
      </template>
      <template #cell(tolanmagan_debt)="props">
        {{ $_moneyFormatter(props.item.tolanmagan.month_debt) }}
      </template>
      <template #cell(barter_debt)="props">
        {{ $_moneyFormatter(props.item.barter.month_debt) }}
      </template>
      <template #cell(other_debt)="props">
        {{ $_moneyFormatter(props.item.other.month_debt) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BCard, BSpinner, BTr, BTh, BTable } from 'bootstrap-vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: true,
      relatedPerson: [
        { ru: 'Ифтихор', uz: 'Iftixor' },
        { ru: 'Элбек', uz: 'Elbek' },
        { ru: 'Гиёс', uz: 'Giyos' },
        { ru: 'Шуҳрат', uz: 'Shuhrat' },
        { ru: 'Элёр', uz: 'Elyor' },
        { ru: 'Феруз', uz: 'Feruz' },
        { ru: 'Ходим', uz: 'Xodim' },
        { ru: 'Нет оплаты', uz: "To'lanmagan" },
        { ru: 'Бартер', uz: 'Barter' },
        { ru: 'Прочие', uz: 'Boshqalar' },
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'title',
          label: 'navbars.object_name',
        },
        {
          key: 'total_month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'total_month_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'iftixor.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'iftixor_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'elbek.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'elbek_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'giyos.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'giyos_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'shuhrat.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'shuhrat_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'elyor.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'elyor_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'feruz.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'feruz_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'xodim.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'xodim_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'tolanmagan.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'tolanmagan_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'barter.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'barter_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'other.month_debt_count',
          label: 'general.count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'other_debt',
          label: 'general.cost',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },

  computed: {
    ...mapGetters('objects', ['GET_RELATED_PERSON']),
    totalMonthDebt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.total_month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    totalMonthDebtCount() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.total_month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    iftixor_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.iftixor.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    iftixor_debt() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.iftixor.month_debt
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    elbek_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.elbek.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    elbek_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.elbek.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    giyos_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.giyos.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    giyos_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.giyos.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    shuhrat_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.shuhrat.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    shuhrat_debt() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.shuhrat.month_debt
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    elyor_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.elyor.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    elyor_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.elyor.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },

    feruz_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.feruz.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    feruz_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.feruz.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },

    xodim_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.xodim.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    xodim_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.xodim.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    tolanmagan_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.tolanmagan.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    tolanmagan_debt() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.tolanmagan.month_debt
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    barter_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.barter.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    barter_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.barter.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    other_debt_count() {
      const data = this.GET_RELATED_PERSON.map(
        (item) => item.other.month_debt_count
      )
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    other_debt() {
      const data = this.GET_RELATED_PERSON.map((item) => item.other.month_debt)
      return data.reduce((oldValue, newValue) => oldValue + newValue, 0)
    },
    reChangeFormat() {
      const dataObject = [
        {
          title: this.$t('general.last'),
          total_month_debt: this.totalMonthDebt,
          total_month_debt_count: this.totalMonthDebtCount,
          iftixor: {
            month_debt_count: this.iftixor_debt_count,
            month_debt: this.iftixor_debt,
          },
          elbek: {
            month_debt_count: this.elbek_debt_count,
            month_debt: this.elbek_debt,
          },
          giyos: {
            month_debt_count: this.giyos_debt_count,
            month_debt: this.giyos_debt,
          },
          shuhrat: {
            month_debt_count: this.shuhrat_debt_count,
            month_debt: this.shuhrat_debt,
          },
          elyor: {
            month_debt_count: this.elyor_debt_count,
            month_debt: this.elyor_debt,
          },
          feruz: {
            month_debt_count: this.feruz_debt_count,
            month_debt: this.feruz_debt,
          },
          xodim: {
            month_debt_count: this.xodim_debt_count,
            month_debt: this.xodim_debt,
          },
          tolanmagan: {
            month_debt_count: this.tolanmagan_debt_count,
            month_debt: this.tolanmagan_debt,
          },
          barter: {
            month_debt_count: this.barter_debt_count,
            month_debt: this.barter_debt,
          },
          other: {
            month_debt_count: this.other_debt_count,
            month_debt: this.other_debt,
          },
        },
      ]
      return [...this.GET_RELATED_PERSON, ...dataObject]
    },
  },

  mounted() {
    this.FETCH_RELATED_PERSON().then(() => {
      this.loader = false
    })
  },

  methods: {
    ...mapActions('objects', ['FETCH_RELATED_PERSON']),
  },
}
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}

.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}
</style>
